/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { LuWaves } from 'react-icons/lu';
import { toItineraryRows } from '../../utils/cruiseUtils';

const dotClass = (row) => {
  if (row.atSea) return 'is-sea';
  if (row.isEnd) return 'is-end';
  return '';
};

function CruiseItinerary({ stops }) {
  const rows = toItineraryRows(stops);
  if (!rows.length) {
    return <div className="cr-empty-inline">Itinerary is not available.</div>;
  }
  return (
    <div className="cr-itinerary">
      {rows.map((r) => (
        <div className="cr-itinerary__row" key={r.key}>
          <div className="cr-itinerary__day">
            <div className="cr-itinerary__day-label">{r.day}</div>
            <div className="cr-muted-sm">{r.date}</div>
          </div>
          <div className="cr-itinerary__rail">
            <span className={`cr-itinerary__dot ${dotClass(r)}`} />
            {!r.isLast && <span className="cr-itinerary__line" />}
          </div>
          <div className="cr-itinerary__stop">
            {r.atSea ? (
              <div className="cr-itinerary__sea">
                <LuWaves size={16} />
                Day at sea
              </div>
            ) : (
              <div className="cr-itinerary__port">{r.port}</div>
            )}
            {(r.arrive || r.depart || r.boarding) && (
              <div className="cr-itinerary__times">
                {r.arrive && <span>{r.arrive}</span>}
                {r.depart && <span>{r.depart}</span>}
                {r.boarding && (
                  <span className="cr-text-success">{r.boarding}</span>
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

CruiseItinerary.propTypes = {
  stops: PropTypes.array.isRequired,
};

export default CruiseItinerary;
